//mobile
    if (window.innerWidth < 1024){
        let sliderPosMobile;
        var showValueMobile;
        $(".slidingContrastChartSliderMobile").on("input", function(e) {
            sliderPosMobile = +$(".slidingContrastChartSliderMobile").val();
            // var showValueMobile = (2 - sliderPosMobile / 100).toFixed(1);
            // $(".slideValue").text('f '+showValueMobile);


            if (sliderPosMobile <= 50){
                showValueMobile = parseFloat(Math.abs((sliderPosMobile - 50) / 100).toFixed(1)) + parseFloat(1);
                $(".slideValueMobile").text('f ' + showValueMobile.toFixed(1));
            }else {
                showValueMobile = parseFloat(Math.abs((sliderPosMobile - 50) / 50).toFixed(1)) + parseFloat(1);
                $(".slideValueMobile").text('f ' + showValueMobile.toFixed(1));
            }
            var brightnessMobile;
            if (( Math.abs( showValueMobile - 2)) > 0.2){
                brightnessMobile =  Math.abs(showValueMobile - 2);
            }else {
                brightnessMobile = 0.2;
            }

            $(".slidingContrastChartImageMobile").css('filter','grayscale('+(Math.abs(1 - showValueMobile) )+') sepia('+( Math.abs(1 - showValueMobile) )+') brightness('+brightnessMobile+')');
            $(".slidingContrastChartSliderButtonMobile").css("left",'calc(' + $(".slidingContrastChartContentMobile").outerWidth() * (sliderPosMobile / 100) + 'px - clamp(0rem, 8vw, 6rem))');
            $(".partingLine").css("left",'calc(' + $(".slidingContrastChartContentMobile").outerWidth() * (sliderPosMobile / 100) + 'px');
        })
    }
